import { initObjData } from '@/utils/tool'

const form = {
  props: {
    formType: {
      type: String,
      default: 'create'
    },
    initFormData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    formDataInit(form, initFormData = {}) {
      initObjData(form, initFormData)
    },
    submitFormSuccess(flag = true) {
      this.$emit('submitFormSuccess', flag)
    }
  }
}

export { form }
